import { Fragment } from "react";
import { FieldTableName } from "../../fields/FieldTableName";
import { FieldTableKey } from "../../fields/FieldTableKey";
import { ToolSpec } from "components/ToolParamsGrid/ToolParamsGrid.types";
import { EuiSpacer, EuiText } from "@inscopix/ideas-eui";
import { FieldTool } from "../../fields/FieldTool";

interface StepTableInfoProps {
  toolSpec: ToolSpec | undefined;
  setToolSpec: (toolSpec: ToolSpec | undefined) => void;
  setToolVersionId: (toolVersionId: number | undefined) => void;
  tableName: { value: string; isDirty: boolean };
  setTableName: (tableName: string, isDirty: boolean) => void;
  tableKey: { value: string; isDirty: boolean };
  setTableKey: (tableKey: string, isDirty: boolean) => void;
  columnGroupName: { value: string; isDirty: boolean };
  setColumnGroupName: (columnGroupName: string, isDirty: boolean) => void;
  paramKeys: { value: string[]; isDirty: boolean };
  setParamKeys: (paramKeys: string[], isDirty: boolean) => void;
}

export const StepTableInfo = ({
  toolSpec,
  setToolSpec,
  setToolVersionId,
  tableName,
  setTableName,
  tableKey,
  setTableKey,
  columnGroupName,
  setColumnGroupName,
  paramKeys,
  setParamKeys,
}: StepTableInfoProps) => {
  return (
    <Fragment>
      <EuiText>
        <h4>Table info</h4>
      </EuiText>

      <EuiSpacer size="s" />

      <EuiText size="s">
        <p>Select an analysis for the table to use.</p>
      </EuiText>

      <EuiSpacer />

      <FieldTool
        value={toolSpec}
        onChange={(spec, toolVersionId) => {
          setToolSpec(spec);
          setToolVersionId(toolVersionId);
          const defaultTableName = spec?.name ?? "";

          if (!tableName.isDirty) {
            setTableName(defaultTableName, false);
          }

          if (!columnGroupName.isDirty) {
            setColumnGroupName(defaultTableName, false);
          }

          if (!paramKeys.isDirty) {
            const resultKeys = spec?.results.flatMap((result) =>
              result.files.map((file) => file.result_key),
            );
            setParamKeys(resultKeys ?? [], false);
          }
        }}
      />

      <FieldTableName
        label="Table name"
        value={tableName.value}
        onChange={({ value }) => {
          setTableName(value, true);

          if (!tableKey.isDirty) {
            const defaultKey = value.slice(0, 3).toUpperCase();
            setTableKey(defaultKey, false);
          }

          if (!columnGroupName.isDirty) {
            setColumnGroupName(value, false);
          }
        }}
      />

      <FieldTableKey
        label="Table key"
        value={tableKey.value}
        onChange={({ value }) => {
          setTableKey(value, true);
        }}
        tableName={tableName.value}
        autoGenerate={!tableKey.isDirty}
        onAutoGenerate={(key) => {
          setTableKey(key, false);
        }}
      />
    </Fragment>
  );
};
